import React from 'react'
import { Skeleton, Button, Form, Input, message, Select } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../BaseComponent'
import ISpecie from '../../../interfaces/ISpecie'
import { SearchRequest, SpecieSaveRequest }from '../../../services/api/interfaces/ApiRequest'

type CreditsProps = BaseFormComponentProps & {
  uuid?: string,
  data?: ISpecie,
  error: any | null,

  loading: boolean,
  history: any,

  loadCredits: (args: SearchRequest) => void,

  sheltersToFilter: any[],
  loadSheltersDispatch: (args: any) => void,

  dispatchCreate: (args: SpecieSaveRequest) => Promise<any>,
  dispatchUpdate: (args: SpecieSaveRequest) => Promise<any>
}

export default class Credits extends FormComponent<CreditsProps> {

  state = {
    saving: false,
    loaded: false
  }

  componentDidMount() {
    const { uuid, loadCredits, loadSheltersDispatch } = this.props

    // Check permissions
    this.validateAccessPermissions()

    if (uuid) {
      loadCredits({
        search: {
          uuid
        }
      })
    }

    loadSheltersDispatch({})
  }

  componentDidUpdate(prevProps: CreditsProps, prevState) {
    const wasLoading = prevProps.loading && !this.props.loading
    let newState = Object.assign({}, this.state)

    // Check permissions
    this.validateAccessPermissions()

    // We are loaded?
    if (!this.state.loaded) {
      // If our entity was loaded or if we are creating a new one, that's means that we are loaded :P
      if (wasLoading || !this.props.uuid) {
        newState.loaded = true
      } 
    } else {
      // We are saving
      if (this.state.saving && wasLoading) {

        if (!this.props.error) {
          message.success('Specie saved successfully!')
        } else {
          message.error('Failed to save user. Error: ' + this.props.error)
        }

        newState.saving = false
      }
    }

    // Update if changed
    if (newState.loaded !== this.state.loaded) {
      this.setState(newState)
    }
  }

  handleSave = (values: any) => {
    const { uuid, dispatchCreate, dispatchUpdate } = this.props

    let payload: any = {
        ...values,
        amount: parseFloat(values.amount)
    }
    console.log("vai chamar")

    if (uuid) {
      payload = {
        ...payload,
        uuid
      }
      
      dispatchUpdate(payload)
      this.setState({
        saving: true
      })
    } else {
      dispatchCreate(payload)
    }
  }

  render() {
    const { uuid, data, loading, sheltersToFilter } = this.props
    const { loaded } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    let values:any = {
      name: ''
    }

    if (uuid) {
      values = {
        ...data || {}
      }
    }

    /*
    admin/payment-credit/create-voucher
shelter_uuid
amount
label*/

    return (
      <Form
        name="credits"
        initialValues={values}
        layout="vertical"
        onFinish={this.handleSave}
      >
        <Form.Item
          label="Shelter name"
          name="shelter_uuid"
          rules={[
            {
              required: true,
              message: 'Missing a shelter name'
            }
          ]}
        >
          <Select options={sheltersToFilter} />
        </Form.Item>

        <Form.Item
          label="Amount"
          name="amount"
          rules={[
            {
              required: true,
              message: 'Missing an amount'
            },
            {
              validator: (rule, value, callback) => {
                if (value < 10) {
                  callback('Amount must be equal or greater than 10')
                }else{
                  return Promise.resolve()
                }
              }
            }
          ]}
        >
          <Input type="number" />
        </Form.Item>

        <Form.Item
          label="Description"
          name="label"
        >
          <Input />
        </Form.Item>
        <Form.Item style={{marginTop: 32}}>
          <Button type="primary" htmlType="submit" size="large" loading={loading} ref={(refs) => this.actionRefs.save = refs} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    )
  }
}